// extracted by mini-css-extract-plugin
module.exports = {"icon":"_20hnGtQf0Tqp9qqjZuT5GM"};